module.exports = __webpack_public_path__ + "static/media/chevron-blue-left.dfec8b59.svg";